
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","stroke":"#000","opacity":".4","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M1.666 10c0-3.536 0-5.303 1.22-6.402C4.106 2.5 6.071 2.5 10 2.5c3.929 0 5.893 0 7.113 1.098 1.22 1.099 1.22 2.866 1.22 6.402s0 5.303-1.22 6.402C15.892 17.5 13.928 17.5 10 17.5c-3.928 0-5.892 0-7.113-1.098-1.22-1.099-1.22-2.867-1.22-6.402z","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M7 6.667h-.667c-.628 0-.942 0-1.138.195C5 7.057 5 7.372 5 8v.667c0 .628 0 .942.195 1.138.196.195.51.195 1.138.195H7c.629 0 .943 0 1.138-.195.195-.196.195-.51.195-1.138V8c0-.629 0-.943-.195-1.138-.195-.195-.51-.195-1.138-.195z","stroke-width":"1.5","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M5 13.333h3.333M11.666 6.667h3.333M11.666 10h3.333M11.666 13.333h3.333","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    